import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../../atoms';

// components
import { Trash2, X } from 'lucide-react';

// ----------------------------------------------------------------------

export type ConfirmDialogProps = {
  title: string;
  content?: string;
  action: React.ReactNode;
  open: boolean;
  onClose: VoidFunction;
  cancelBtnText?: string;
};

const ConfirmDeleteDialog = ({
  title,
  content,
  action,
  open,
  onClose,
  cancelBtnText = 'Cancel',
  ...other
}: ConfirmDialogProps) => {
  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) onClose();
      }}
      {...other}
    >
      <DialogContent />

      <DialogContent>
        <DialogHeader>
          <DialogTitle className='flex items-center min-h-[76px]'>
            <div className='flex items-center'>
              <Trash2 size={24} className='mr-2' />
              {title}
            </div>
            <Button
              size='sm'
              aria-label='close'
              onClick={onClose}
              className='absolute top-3 right-3 '
            >
              <X size={21} />
            </Button>
          </DialogTitle>
        </DialogHeader>
        {content ?? <></>}
        <DialogFooter>
          {action}

          <Button variant='outline' color='inherit' onClick={onClose}>
            {cancelBtnText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
